import { Grid, TableCell } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";

const widthOfSelectColumn = "50px";

export const Container = styled(Grid)(({ theme }) => ({
  overflow: "auto",

  "& .MuiTableHead-root": {
    "& .MuiTableRow-root": {
      height: "56px",
      "& .MuiTableCell-root": {
        backgroundColor: theme.palette.background.paper,
        "&:first-of-type": {
          borderRadius: "12px 0px 0px 12px",
        },
        "&:last-of-type": {
          borderRadius: "0px 12px 12px 0px",
        },
        "& .MuiTypography-root": {
          fontWeight: 500,
        },
      },
    },
  },

  "& .MuiTableRow-root": {
    "& .MuiTableCell-root": {
      "&:first-of-type": {
        textAlign: "center",
        padding: 0,
        width: widthOfSelectColumn,
      },
    },
  },
}));

export const TableContainer = styled(Grid)({
  width: "100%",
  minWidth: "500px",
});

export const StyledTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "align",
})<{ align?: "left" | "center" | "right"; width?: number }>(
  ({ width, theme }) => ({
    ...(!!width && {
      width: `${width}%`,
    }),
  }),
  ({ align, theme }) => ({
    ...(!!align && {
      textAlign: align,
    }),
  })
);

export const TotalContainer = styled(Grid)(({ theme }) => ({
  height: "60px",
  paddingLeft: "10px",
  alignItems: "center",
  backgroundColor: lighten(theme.palette.secondary.light, 0.9),
}));
